import React, { useState } from "react";
import "./TextLong.css";

export default function TextToggle({ isMobile, textToggleTitle, textToggleContent }) {
    const [toggled, setToggled] = useState(false);
    const width = window.innerWidth;

    if (!textToggleTitle) {
        return null;
    }

    const tagToComponent = {
        h: "text-long-highlight",
        t: "text-title",
        q: "text-quote",
        s: "text-long-space",
        b: "text-long-bold",
        i: "text-long-italic",
        wh: "text-long-white",
        l: (content) => (
            <a
                className="text-long-link-toggle"
                rel="noreferrer"
                href={content.split("(")[1].split(")")[0]}
                target="_blank"
            >
                {content.split("(")[0]}
            </a>
        ),
    };

    const processParagraph = (paragraph) => {
        const splitForOpeningTag = paragraph.split("<");

        const processNoTag = (seg) => {
            const splitForClosingTag = seg.split(">");
            return splitForClosingTag.length > 1
                ? splitForClosingTag[1]
                : splitForClosingTag[0];
        };

        const processTag = (seg) => {
            const [tag, content] = seg.split(">");

            if (tag in tagToComponent) {
                const TagComponent = tagToComponent[tag];
                if (typeof TagComponent === "function") {
                    return TagComponent(content);
                }
                return <span className={TagComponent}>{content}</span>;
            }
            return content;
        };

        const paragraphClass = isMobile ? "text-long-toggle-mobile" : "text-long-toggle";
        return (
            <p className={paragraphClass} key={paragraph}>
                {splitForOpeningTag.map((s, i) =>
                    i % 2 === 0 ? processNoTag(s) : processTag(s)
                )}
            </p>
        );
    };

    const ToggledContent = () => (
        <div
            style={{
                backgroundColor: "black",
                textAlign: "left",
                overflow: "hidden",
            }}
        >
            {textToggleContent.split("\r\n\r\n").map(processParagraph)}
        </div>
    );

    const containerStyle = {
        position: "relative",
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
        backgroundColor: "black",
        padding: isMobile? "0px 15vw 0px 15vw":"0px 25vw 0px 25vw",
    };

    return (
        <div style={containerStyle}>
            <p className={isMobile ? "text-long-toggle-mobile" : "text-long-toggle"}>
                <span className="text-long-bold" onClick={() => setToggled(!toggled)}>
                    <i className={toggled ? "arrow down" : "arrow right"}></i>
                    {toggled ? "Hide" : " " + textToggleTitle}
                </span>
                {toggled && <ToggledContent />}
            </p>
        </div>
    );
}
